<nz-modal
[nzVisible]="visible"
[nzMaskClosable]="true"
[nzWidth]="900"
(nzOnCancel)="closeModal()"
[nzFooter]="null"
[nzCentered]="true"
>
<ng-container *nzModalContent>

        <div class="toolguide-container">
            <div class="toolguide-header">
                <h2 style="color: white;">Tool Guide: Keyboard Navigation and Input in a Grid</h2>
            </div>
            <div class="toolguide-content">
                <h2>Overview</h2>
                <p>This guide explains keyboard navigation and input in a grid or table.</p>
                <ul>
                    <li><strong>Enter:</strong> Opens an option list or moves to the next column.</li>
                    <li><strong>Ctrl + Enter:</strong> Adds a new line in the current cell.</li>
                    <li><strong>Tab:</strong> Moves to the next cell. If at the end of a row, moves to the first cell of the next row.</li>
                    <li><strong>Arrow Keys:</strong> Navigate between cells.
                        <ul>
                            <li><span class="arrow">→</span> <strong>Right Arrow:</strong> Next cell in the row.</li>
                            <li><span class="arrow">←</span> <strong>Left Arrow:</strong> Previous cell in the row.</li>
                            <li><span class="arrow">↑</span> <strong>Up Arrow:</strong> Cell above.</li>
                            <li><span class="arrow">↓</span> <strong>Down Arrow:</strong> Cell below.</li>
                        </ul>
                    </li>
                </ul>
        
                <div class="toolguide-instructions">
                    <h2>Instructions</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Key</th>
                                <th>Function</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Enter</td>
                                <td>1. Open option list.<br>
                                    2. Select Component and move to the next column.
                                </td>
                            </tr>
                            <tr>
                                <td>Ctrl + Enter</td>
                                <td>Add a new line in the current cell.</td>
                            </tr>
                            <tr>
                                <td>Tab</td>
                                <td>Move to the next cell. If at the end of a row, move to the first cell of the next row.</td>
                            </tr>
                            <tr>
                                <td><span class="arrow">→</span> Right Arrow</td>
                                <td>Move to the next cell in the row.</td>
                            </tr>
                            <tr>
                                <td><span class="arrow">←</span> Left Arrow</td>
                                <td>Move to the previous cell in the row.</td>
                            </tr>
                            <tr>
                                <td><span class="arrow">↑</span> Up Arrow</td>
                                <td>Move to the cell above.</td>
                            </tr>
                            <tr>
                                <td><span class="arrow">↓</span> Down Arrow</td>
                                <td>Move to the cell below.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
        
                <p>Use these keys to navigate and input data efficiently in the grid.</p>
            </div>
            <div class="toolguide-footer"></div>
        </div>
    
    </ng-container>

</nz-modal>